import MultiSelectField, {
  MultiSelectFieldProps,
} from 'components/forms/multiSelectField/MultiSelectField';
import { TriggerActionType } from 'models/automation/Triggers';
import { useTranslation } from 'react-i18next';
import { orderBy } from 'utils/arrayUtils';

interface ActionTypeMultiSelectFieldProps
  extends Omit<MultiSelectFieldProps, 'fieldRenderer' | 'options'> {
  /**
   * Defaults to all TriggerActionType.
   */
  availableActions?: TriggerActionType[];
}

const ActionTypeMultiSelectField = ({
  availableActions = Object.values(TriggerActionType),
  ...props
}: ActionTypeMultiSelectFieldProps) => {
  const { t } = useTranslation();
  const actions = availableActions.map((value) => ({
    label: t('pageAutomations.triggers.actionType', { context: value }),
    value,
  }));
  const options = orderBy(actions, [{ field: 'label', order: 'asc' }]);

  return (
    <MultiSelectField
      colSmInput={8}
      colSmLabel={4}
      isSelectAllEnabled
      label={t('pageAutomations.triggers.filters.actionType')}
      options={options}
      {...props}
    />
  );
};

export default ActionTypeMultiSelectField;
